import { Suspense, useCallback, useEffect, useState } from "react"

// ** Third Party Components
import { Outlet, useLocation } from "react-router-dom"

// ** Styles
import "../global.css"

// ** Helpers
import { cn } from "@pma/utils/helpers"

// ** Theme Components
import PmsLoader from "@pma/components/common/loader"

// ** Custom Hooks
import useTranslator from "@pma/hooks/use-translator"

// ** Custom Components
import Sidebar from "../components/sidebar"
import Header from "../components/header/index"
import BottomNav from "@pma/components/sidebar/BottomNav"
import QuickActions from "@pma/components/header/LeftSection/QuickActions"
import HeaderBreadcrumbs from "@pma/components/header/LeftSection/HeaderBreadcrumbs"
import DeletePermissionToast from "@pma/pages/Project/Task/Common/DeletePermissionToast"

const MainLayout = () => {
  const location = useLocation()
  const { locale } = useTranslator()
  const isHebrew = locale === "he"

  const [isMobile, setIsMobile] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(true)

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen)

  const closeSidebar = useCallback(() => {
    setSidebarOpen(false)
  }, [])

  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 1024 // lg breakpoint
      setIsMobile(mobile)
      // Auto-close sidebar on mobile, auto-open on desktop
      setSidebarOpen(!mobile)
    }

    checkScreenSize()
    window.addEventListener("resize", checkScreenSize)

    return () => window.removeEventListener("resize", checkScreenSize)
  }, [])

  return (
    <div className='flex h-screen bg-indigo-25'>
      <Sidebar
        isOpen={sidebarOpen}
        onClose={closeSidebar}
        className={!sidebarOpen && !isMobile ? "lg:w-0 lg:border-0" : ""}
      />

      <div
        className={cn(
          "flex min-w-0 flex-1 flex-col overflow-hidden rounded-lg border border-neutral-100 lg:py-[10px]",
          isHebrew ? "lg:pl-2.5" : "lg:pr-2.5",
        )}
      >
        <Header onMenuClick={toggleSidebar} />

        <main className='mb-16 flex flex-1 flex-col gap-5 overflow-y-auto rounded-b-lg border-b-[1px] bg-white p-4 pb-20 md:gap-6 md:p-6 md:pb-6 lg:mb-0 lg:pb-6'>
          <div className='flex gap-2 md:hidden'>
            {!location.pathname.includes("setting") ? <QuickActions /> : null}
            <HeaderBreadcrumbs />
          </div>
          <Suspense fallback={<PmsLoader label='Loading Page...' />}>
            <Outlet />
          </Suspense>
        </main>

        <BottomNav />
      </div>

      <DeletePermissionToast />
    </div>
  )
}

export default MainLayout
